import { render, staticRenderFns } from "./dropdown-list.vue?vue&type=template&id=0aa4f005&scoped=true"
import script from "./dropdown-list.vue?vue&type=script&lang=ts"
export * from "./dropdown-list.vue?vue&type=script&lang=ts"
import style0 from "./dropdown-list.vue?vue&type=style&index=0&id=0aa4f005&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa4f005",
  null
  
)

export default component.exports